<template>
    <div>
        <markdown
            :value="issue.description"
            v-on:save-content="changeAttribute"
            :label="$t('issues.actions.add_description')"
            :allow-editing="this.allowEditing"
            v-if="!onlyEdit"
        />
        <editor v-model="editingValue" v-if="onlyEdit" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import markdown from '@/components/shared/markdown';
import editor from '@/components/shared/editor';

export default {
    name: 'issue-description',
    data: () => ({
        editing: false,
        editingValue: undefined,
    }),
    props: {
        issue: {},
        allowEditing: {
            default: true,
        },
        onlyEdit: {
            default: false,
        },
    },
    components: {
        markdown,
        editor,
    },
    watch: {
        editingValue: function (e) {
            if (this.onlyEdit) {
                this.$emit('input', e);
            }
        },
    },
    computed: {
        ...mapGetters(['profile']),
    },
    methods: {
        ...mapActions(['updateIssue']),
        async changeAttribute(value) {
            await this.updateIssue({
                id: this.issue.id,
                description: value,
            });

            this.editing = false;
            this.$emit('change-attribute-value');
        },
    },
};
</script>
